import React from "react";
import {StringParam, useQueryParam} from "use-query-params";
import {useLocation, useHistory} from "react-router-dom";
import {useSelector} from "react-redux";
import _ from "lodash";

export const usePrevious = function (value) {
	const ref = React.useRef();

	React.useEffect(() => {
		ref.current = value;
	}, [value]);

	return ref.current;
};

/**
 * @param initial Initial tab name
 * @returns {[String, Function]}
 */
export const useQueryStringTabs = function (initial) {
	const [queryTab, setQueryTab] = useQueryParam('tab', StringParam);
	const [tab, setTab] = React.useState(queryTab || initial);

	React.useEffect(() => {
		setQueryTab(tab);
	}, [tab]);

	return [tab, setTab];
};

export const useHashTabs = function (initial) {
	const location = useLocation();
	const history = useHistory();
	const [tab, setTab] = React.useState((location.hash || initial).replace(/^#/, ''));

	React.useEffect(() => {
		const removeListener = history.listen((location, action) => {
			setTab((location.hash || initial).replace(/^#/, ''));
		});

		return () => {
			removeListener();
		};
	}, []);

	return tab;
};

export const useDidMountEffect = function(fn, inputs) {
	const didMountRef = React.useRef(false);

	React.useEffect(() => {
		if (didMountRef.current)
			fn();
		else
			didMountRef.current = true;
	}, inputs);
};

export const useHasRole = function(roles) {
	const {user} = useSelector(({authentication}) => authentication);

	return _.includes(roles, user.role);
};